<div bsModal #materialSelectorTable="bs-modal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="materialSelectorTable" aria-hidden="true" [config]="{backdrop: false}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bold">
                {{ l('SelectMaterials')}}
            </div>
            <div class="modal-body">
                <material-table-filter (onFiltersChange)="filtersChange($event)"></material-table-filter>
                <table class="table table-borderless table-md">
                    <thead>
                        <tr>
                            <th>{{ l("Name") }}</th>
                            <th>{{ l("Supplier") }}</th>
                            <th>{{ l("Unit") }}</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr class="d-block coloured">
                            <td colspan="3">
                                <label class="label-color">{{ l("Recent") }}  </label>
                                <button [disabled]="saving" type="button" class="btn btn-link"
                                (click)="ClearRecent()">{{l("Clear")}}</button>
                            </td>
                        </tr>
                        <ng-container *ngFor="let material of this.filteredMaterials">
                            <tr *ngIf="material.wasRecentlyAssigned && material.filterShow" (click)="selectMaterial(material, !material.selected)">
                                <td>
                                    <div class="row">
                                        <div class="col-sm-1">
                                            <i *ngIf="material.selected == true"
                                                class="fas fa-check-square main-color cb mr-2"
                                                ></i>
                                            <i *ngIf="material.selected == false" class="fas fa-square cb mr-2"
                                                ></i>

                                        </div>
                                        <div class="col-sm-10">
                                            {{material.name}}
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    {{ material.supplier }}
                                </td>
                                <td>
                                    {{ material.unit }}
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="!checkFilteredMaterialNull(this.filteredMaterials)" class="d-block coloured">
                            <td colspan="3">
                                <label class="label-color">{{ l("All") }}  </label>
                            </td>
                        </tr>
                        <tr *ngIf="checkFilteredMaterialNull(this.filteredMaterials)"><td colspan="3">{{ l('NoResultsFound') }}</td></tr>
                        <ng-container *ngFor="let material of this.filteredMaterials">
                            <tr *ngIf="!material.wasRecentlyAssigned && material.filterShow" (click)="selectMaterial(material, !material.selected)">
                                <td>
                                    <div class="row">
                                        <div class="col-sm-1">
                                            <i *ngIf="material.selected == true"
                                                class="fas fa-check-square main-color cb  mr-2"></i>
                                            <i *ngIf="material.selected == false" class="fas fa-square cb  mr-2"></i>
                                        </div>
                                        <div class="col-sm-10">
                                            {{material.name}}  ({{material.materialId}})
                                        </div>
                                    </div>
                                </td>
                                <td>

                                    {{ material.supplier }}
                                </td>
                                <td>

                                    {{ material.unit }}
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button [disabled]="saving" type="button" class="btn btn-primary"
                    (click)="close()">{{l("Close")}}</button>
            </div>
        </div>
    </div>
</div>
<table class="table table-borderless rows-no-padding assign-materials-table">
    <tr *ngFor="let material of getSelectedMaterial(); let i = index" class="table-row">
        <td class="align-middle display-table-items-center">
            <i class="fas fa-check-square main-color margin-right-5"></i>
            {{ material.materialDetails.name }} ({{material.materialDetails.materialId}})
        </td>
        <td class="align-middle text-sm-right display-table-items-center">
            <input *ngIf="!isAllocationSheet()"
                [(ngModel)]="material.actualHours"
                (blur)="updateAllocatedMaterialList($event)"
                [disabled]="controlDisabled"
                class="form-control form-control-sm float-right"
                style="max-width: 80px"
                step=".01"
                onKeyPress="if((!this.value.includes('.') && this.value.length >= 4 && event.key !== '.') || (this.value.includes('.') && this.value.split('.')[1].length >= 4)) return false"
                [disabled]="controlDisabled"
                type="number" min="1" max="24" required />
            <span *ngIf="isAllocationSheet()">
                {{ material.actualHours }}
            </span>

        </td>
        <td class="align-middle cell-btn-delete display-table-items-center">
            <button *ngIf="!isAllocationSheet()" class="btn btn-sm" [disabled]="controlDisabled"
                (click)="removeItem(material.materialId)">
                <i class="fa fa-trash"
                data-toggle="popover"
                data-trigger="hover"
                data-html="true"
                [popover]="popTemplate"
                triggers="mouseenter:mouseleave"></i>

                <ng-template #popTemplate>
                    <div [innerHtml]="getMaterialDeleteToolTip(material)"></div>
                </ng-template>
            </button>
        </td>
    </tr>
</table>
<button class="btn btn-default" *ngIf="!isAllocationSheet()" [disabled]="controlDisabled" (click)="show()">
    <i class="fas fa-plus"></i> {{ l("Add") }}
</button>
<div class="validation-msg" *ngIf="showError() && !anyResourceSelected">{{ l('MinResourceSelectionCriteria') }}</div>
